import * as React from 'react'
import * as ReactDOM from 'react-dom'
import * as classnames from 'classnames'
import {Popover as PopoverBase} from './base'

interface PopoverProps {
  attachTop?: boolean
  popoverClass?: string
  noArrow?: boolean
  trigger: React.ReactNode
  children: React.ReactNode
}

export default class Popover extends React.Component<PopoverProps> {
  private static defaultProps = {
    attachTop: false,
    noArrow: false
  }

  public readonly popover: PopoverBase

  constructor(props: PopoverProps) {
    super(props)
    this.popover = new PopoverBase({
      attachTop: this.props.attachTop,
      className: this.props.popoverClass
    })
  }

  public open: React.ReactEventHandler = ev => {
    ev.stopPropagation()
    if (!this.popover.is_open) {
      ev.preventDefault()
      this.popover.open(ev.currentTarget)
    }
  }

  public componentWillUnmount() {
    this.popover.end()
  }

  public render() {
    return (
      <React.Fragment>
        <span onClick={this.open}>{this.props.trigger}</span>
        <Portal target={this.popover.node}>
          <Wrapper
            attachTop={this.props.attachTop}
            noArrow={this.props.noArrow}
          >
            {this.props.children}
          </Wrapper>
        </Portal>
      </React.Fragment>
    )
  }
}

const Wrapper: React.FunctionComponent<{
  attachTop?: boolean
  noArrow?: boolean
}> = props => {
  const direction = props.attachTop ? 'down' : 'up'
  const arrow = !props.noArrow && (
    <span className={classnames('arrow', direction)} />
  )

  return (
    <React.Fragment>
      {props.attachTop || arrow}
      <div className="popover-content">{props.children}</div>
      {props.attachTop && arrow}
    </React.Fragment>
  )
}

const Portal: React.FunctionComponent<{target: HTMLElement}> = props =>
  ReactDOM.createPortal(props.children, props.target)
